import React, { Component } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Tooltip, Select, Flex as FlexBox } from '@bijie/react-bnb';
import { Link } from '../../routes';
import { getLabel } from '../../utils/i18n';
import withI18n from '../../utils/withI18n';
import Container from '../Container';
import Icon from '../Icon';
import copyText from '../../utils/copy';

const Wrap = styled.div``;

const WrapSelect = styled(Select)`
  font-family: ${({ theme }) => theme.fontIBMRegular};

  .bnc-select-dropdown-menu {
    max-height: 240px;
  }
`;

const LanguageDropDownBox = styled.div`
  margin-top: 40px;
  text-align: center;
`;

const HeadBox = styled(FlexBox)`
  width: 100%;
  height: calc(100vh - 60px);
  background: #555;
  color: #fff !important;
  text-align: center;
  align-items: center;
  z-index: 22;
  position: relative;
  @media screen and (max-height: 768px) {
    height: auto;
  }
  > div {
    width: 100%;
    height: 100%;
    position: relative;
    > .des {
      width: 100%;
      height: 100%;
      text-align: center;
      padding-top: 200px;
      background: url(${require('./img/community.jpg')}) center center;
      background-size: cover;
      @media screen and (max-height: 768px) {
        height: calc(100vh - 60px);
        min-height: 559px;
      }
    }
    > .item {
      width: 100%;
      height: 100px;
      position: absolute;
      left: 0;
      bottom: 100px;
      @media screen and (max-height: 768px) {
        position: static;
        background: #fafafa;
        padding: 60px 0;
        height: 230px;
      }
    }
  }
  h3 {
    margin-bottom: 0;
    height: 104px;
    font-size: 80px;
    font-family: ${({ theme }) => theme.fontIBMExtraLight};
    font-weight: 300;
    color: rgba(255, 255, 255, 1) !importants;
    line-height: 104px;
  }
  h4 {
    height: 64px;
    font-size: 24px;
    font-family: ${({ theme }) => theme.fontIBMRegular};
    font-weight: 500;
    color: rgba(255, 255, 255, 1) !important;
    line-height: 32px;
    margin: 40px auto;
    margin-bottom: 0px;
    max-width: 926px;
  }
`;

const BannersTitle = styled.h1`
  font-size: 54px;
  font-family: ${({ theme }) => theme.fontIBMLight};
  font-weight: 200;
  line-height: 72px;
  text-align: center;
  ${({ hasMargin }) => (hasMargin ? 'margin: 100px auto 0px;' : 'margin: 67px auto 0px;')};
  ${({ hasColor }) => (hasColor ? 'color:rgba(0,0,0,1);' : null)};
`;

const Introduction = styled.p`
  height: 20px;
  font-size: 16px;
  font-family: ${({ theme }) => theme.fontIBMBold};
  font-weight: bold;
  color: rgba(255, 255, 255, 1);
  line-height: 20px;
  text-align: center;
  margin-top: 8px;
  margin-bottom: 0;
`;

const CategoryList = styled.div`
  margin: 0 auto;
  padding-bottom: 100px;
`;

const BannersToUnderstanding = styled.p`
  font-size: 16px;
  font-family: ${({ theme }) => theme.fontIBMMedium};
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 22px;
  text-align: center;
  ${({ hasMarginTop }) => (hasMarginTop ? 'margin-top: 25px;' : null)};
  margin-bottom: 40px;
`;

const ListHeaderLogo = styled.div`
  text-align: center;
  padding-top: 0;
  padding-bottom: 72px;
`;
const ListHeaderTitle = styled.p`
  width: 25%;
  height: 100px;
  float: left;
  font-size: 24px;
  font-family: ${({ theme }) => theme.fontIBMMedium};
  font-weight: 500;
  color: rgba(33, 40, 51, 1);
  line-height: 32px;
  padding-top: 20px;
  margin-bottom: 0;
`;
const ListOne = styled.div`
  width: 1200px;
  padding: 20px;
  overflow: hidden;
`;

const TGChannelItem = styled.li`
  float: left;
  display: block;
  padding: 20px;
  position: relative;
  height: 100px;
  ${({ hasMargin }) => (hasMargin ? 'margin: 2px;' : null)};
  ${({ largeWidth }) => (largeWidth ? 'width: 33.33%;' : 'width: 25%;')};
  ${({ hasBorder }) => (hasBorder ? 'border: 1px solid #f2f2f2;' : null)};
  ${({ hasMarginTop }) => (hasMarginTop ? 'margin-top: 25px;' : null)};
  ${({ hasMarginRight }) => (hasMarginRight ? 'margin-right: 25px;' : null)};
  > h4 {
    font-size: 16px;
    color: rgba(33, 40, 51, 1);
    line-height: 20px;
  }
  p {
    float: right;
    width: 80px;
    right: -10px;
  }
  > a {
    font-size: 14px;
    color: rgba(72, 81, 93, 1);
    line-height: 18px;
    font-family: ${({ theme }) => theme.fontIBMRegular};
  }
  :hover {
    box-shadow: 0px 0px 40px 0px rgba(0, 0, 0, 0.06);
    border-radius: 5px;
    border: none;
    p {
      display: block;
    }
    > a {
      color: #f0b90b;
    }
  }
`;
const RowFlxBox = styled(FlexBox)`
  width: 75%;
  float: left;
`;
const LowerMiddle = styled.div`
  width: 100%;
  background: #fafafa;
  margin: 0px;
  padding-bottom: 120px;
  & .TGList {
    margin-top: 25px;
  }
  h3 {
    font-size: 56px;
    font-family: ${({ theme }) => theme.fontIBMLight};
    color: rgba(33, 40, 51, 1) !important;
    line-height: 72px;
    text-align: center;
    padding-top: 100px;
    margin-bottom: 0;
    font-weight: 200;
  }
  h4 {
    font-size: 16px;
    line-height: 20px;
    margin-top: 25px;
    margin-bottom: 0;
    text-align: center;
  }
`;

const MediaNavList = styled(FlexBox)`
  width: 1260px;
  list-style: none;
  margin: 0 auto;
  margin-bottom: 0;
  height: 100px;
  box-sizing: border-box;
  padding: 0 90px;
`;
const MediaNavItem = styled.div`
  width: 80px;
  height: auto;
  list-style: none;
  & a {
    display: inline-block;
    color: #fff;
    @media screen and (max-height: 768px) {
      color: rgba(33, 40, 51, 1);
    }
    > p {
      @media screen and (max-height: 768px) {
        color: rgba(33, 40, 51, 1);
      }
    }
    &:hover {
      & i {
        color: #f0b90b;
      }
      & p {
        color: #f0b90b;
      }
    }
  }
`;

const LanguageSelect = styled.div`
  display: flex;
  align-items: center;
  width: 485px;
  height: 50px;
  background: rgba(255, 255, 255, 1);
  border-radius: 25px;
  border: 1px solid rgba(234, 236, 239, 1);
  line-height: 50px;
  margin: 0 auto;
  position: relative;
  overflow: hidden;

  .LanguageSelectSpan {
    width: 46px;
    height: 50px;
    line-height: 50px;
    margin-right: 10px;
    font-size: 26px;
    color: #e6e6e6;
    display: block;
    margin-left: 15px;
  }

  > select {
    width: 335px;
    height: 50px;
    color: red;
    background: rgba(255, 255, 255, 1);
    & .bnc-select-selection--single {
      border: none;
    }
  }

  .bnc-select-selection {
    border: none;
  }

  .bnc-select-arrow {
    position: absolute;
    right: -60px;
  }
`;

const CommunitiesItemWrap = styled.div`
  overflow: hidden;
  padding: 0 20px 20px 20px;
  h2 {
    font-size: 24px;
    color: rgba(33, 40, 51, 1) !important;
    line-height: 32px;
    margin-left: 18px;
    margin-bottom: 20px;
    margin-top: 100px;
  }
`;

const CenterIconBtn = styled.p`
  width: 66px;
  margin: 0px;
  padding: 0px;
  position: absolute;
  top: 10px;
  right: 10px;
  display: none;
  span {
    width: 30px;
    height: 30px;
    overflow: hidden;
    display: inline-block;
    background: rgba(240, 185, 11, 0.2);
    margin-right: 6px;
    border-radius: 15px;
    text-align: center;
    cursor: pointer;
    &:hover {
      background: #f0b90b;
      i {
        color: white;
      }
      path {
        fill: #fff;
      }
    }
    i {
      line-height: 30px;
    }
    .Copylink-x {
      display: block;
    }
  }
`;

const StyledOverlay = styled.span`
  overflow: hidden;
  height: 60px;
  .shareItem {
    margin-right: 10px;
    display: inline-block;
    width: 30px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    border-radius: 15px;
    border: 1px solid #eaecef;
  }
  .facebook {
    color: #29448a;
    &:hover {
      color: #fff;
      background: #29448a;
    }
  }
  .twitter {
    color: #1e91f1;
    &:hover {
      color: #fff;
      background: #1e91f1;
    }
  }
  .linkedin {
    color: #0375b4;
    &:hover {
      color: #fff;
      background: #0375b4;
    }
  }
  .weibo {
    color: #d22428;
    &:hover {
      color: #fff;
      background: #d22428;
    }
  }
  .qq {
    color: #212833;
    &:hover {
      color: #fff;
      background: #212833;
    }
  }
`;

const SpanWithoutMargin = styled.span`
  margin: 0;
`;

type Props = {
  i18n: Object,
  copyMsg: Function,
  shareFacebook: Function,
  shareTwitter: Function,
  shareLinkedIn: Function,
  shareWeibo: Function,
  shareQq: Function,
  shareFacebookId: string,
  shareTwitterId: string,
  shareLinkedInId: string,
  shareWeiboId: string,
  shareQqId: string,
  shareId: string,
  copylinkId: string,
};

const CenterIcon = ({
  copyMsg,
  shareFacebook,
  shareTwitter,
  shareLinkedIn,
  shareWeibo,
  shareQq,
  shareFacebookId,
  shareTwitterId,
  shareLinkedInId,
  shareWeiboId,
  shareQqId,
  shareId,
  copylinkId,
}: Props) => (
  <CenterIconBtn>
    <span onClick={copyMsg}>
      <a className="Copylink-x" id={copylinkId}>
        <Icon type="fuzhi2" size={14} color="#F0B90B" />
      </a>
    </span>
    <SpanWithoutMargin>
      <Tooltip
        placement="top"
        trigger={['hover']}
        overlay={
          <StyledOverlay>
            <a className="shareItem facebook" onClick={shareFacebook} id={shareFacebookId}>
              <Icon type="facebook" />
            </a>
            <a className="shareItem twitter" onClick={shareTwitter} id={shareTwitterId}>
              <Icon type="twitter" />
            </a>
            <a className="shareItem linkedin" onClick={shareLinkedIn} id={shareLinkedInId}>
              <Icon type="linkedin" />
            </a>
            <a className="shareItem weibo" onClick={shareWeibo} id={shareWeiboId}>
              <Icon type="weibo" />
            </a>
            <a className="shareItem qq" onClick={shareQq} id={shareQqId}>
              <Icon type="QQ" />
            </a>
          </StyledOverlay>
        }
      >
        <a id={shareId}>
          <Icon type="Share-xsvg" size={14} color="#F0B90B" />
        </a>
      </Tooltip>
    </SpanWithoutMargin>
  </CenterIconBtn>
);

CenterIcon.defaultProps = {
  copyMsg: () => {},
  shareFacebook: () => {},
  shareLinkedIn: () => {},
  shareQq: () => {},
  shareTwitter: () => {},
  shareWeibo: () => {},
};

const languageOptions = [
  { name: 'العربية' },
  { name: 'Čeština/Slovenčina' },
  { name: 'Nederlands' },
  { name: 'Filipino' },
  { name: 'Français' },
  { name: 'Deutsch' },
  { name: 'עברית' },
  { name: 'India' },
  { name: 'Italiano' },
  { name: '日本語' },
  { name: '한국어' },
  { name: 'Монгол' },
  { name: 'Nigeria' },
  { name: 'Polski' },
  { name: 'Português' },
  { name: 'Română' },
  { name: 'Pусский' },
  { name: 'South Africa' },
  { name: 'Español' },
  { name: 'Türkçe' },
  { name: 'Українська' },
  { name: 'Tiếng Việt' },
  { name: 'Thailand' },
];

const communityOptions = [
  { name: 'العربية', link: 'https://t.me/BinanceArabic' },
  { name: 'Čeština/Slovenčina', link: 'https://t.me/BinanceCzechoSlovakia' },
  { name: 'Nederlands', link: 'https://t.me/BinanceDutch' },
  { name: 'Filipino', link: 'https://t.me/BinanceFilipino' },
  { name: 'Français', link: 'https://t.me/BinanceFrench' },
  { name: 'Deutsch', link: 'https://t.me/BinanceGerman' },
  { name: 'עברית', link: 'https://t.me/BinanceHebrew' },
  { name: 'India', link: 'https://t.me/BinanceIndian' },
  { name: 'Italiano', link: 'https://t.me/BinanceItalian' },
  { name: '日本語', link: 'https://t.me/BinanceJapanese' },
  { name: '한국어', link: 'https://t.me/BinanceKorean' },
  { name: 'Монгол', link: 'https://t.me/BinanceMongolian' },
  { name: 'Nigeria', link: 'https://t.me/BinanceNigeria' },
  { name: 'Polski', link: 'https://t.me/Binance_Polish' },
  { name: 'Português', link: 'https://t.me/BinancePortuguese' },
  { name: 'Română', link: 'https://t.me/BinanceRomanian' },
  { name: 'Pусский', link: 'https://t.me/BinanceRussian' },
  { name: 'South Africa', link: 'https://t.me/BinanceSouthAfrica' },
  { name: 'Español', link: 'https://t.me/BinanceSpanish' },
  { name: 'Türkçe', link: 'https://t.me/BinanceTurkish' },
  { name: 'Українська', link: 'https://t.me/BinanceUkrainian' },
  { name: 'Tiếng Việt', link: 'https://t.me/BinanceVietnamese' },
  { name: 'Thailand', link: 'https://t.me/BinanceThai' },
  { name: 'Greek', link: 'https://t.me/BinanceGreek' },
  { name: 'Croatian', link: 'https://t.me/BinanceCroatian' },
  { name: 'Singapore', link: 'https://t.me/Binance_Singapore' },
  { name: 'Malaysian', link: 'https://t.me/BinanceMalay' },
  { name: 'Baltics', link: 'https://t.me/binance_baltics' },
  { name: 'Uganda', link: 'https://t.me/BinanceUganda' },
  { name: 'Indonesian', link: 'https://t.me/Binance_Indonesian' },
];

export default
@withI18n
class Community extends Component<Props> {
  static propTypes = {
    i18n: PropTypes.object,
  };

  static defaultProps = {
    i18n: {},
  };

  state = {
    lang: '',
  };

  scrollToAnchor = anchorName => {
    if (anchorName) {
      const anchorElement = document.getElementById(anchorName);
      if (anchorElement) {
        anchorElement.scrollIntoView({ block: 'start', behavior: 'smooth' });
      }
    }
  };

  selectChange = a => {
    this.setState({
      lang: a,
    });
  };

  getSelectCommunityOptions = () => {
    const { lang } = this.state;
    if (lang === '') {
      return communityOptions;
    }
    const selectCommunityOptions = [];
    communityOptions.map(item => {
      if (item.name === lang) {
        selectCommunityOptions.push(item);
      }
      return null;
    });
    return selectCommunityOptions;
  };

  render() {
    const selectCommunityOptions = this.getSelectCommunityOptions();
    const { i18n } = this.props;
    return (
      <Wrap>
        <HeadBox direction="row" align="center" justify="center">
          <div>
            <div className="des">
              <h3>{getLabel('exchange-community-join', i18n)}</h3>
              <h4>{getLabel('exchange-community-joinTheDiscussion', i18n)}</h4>
            </div>
            <div className="item">
              <MediaNavList justify="space-between">
                <MediaNavItem>
                  <a onClick={() => this.scrollToAnchor('goTG')} id="Community-a-bannerTelegram">
                    <Icon type="telegram" size={50} />
                    <Introduction>Telegram</Introduction>
                  </a>
                </MediaNavItem>
                <MediaNavItem>
                  <Link to="https://www.facebook.com/binance">
                    <a target="_blank" aria-label="Facebook" id="Community-a-bannerFacebook">
                      <Icon type="facebook" size={50} />
                      <Introduction>Facebook</Introduction>
                    </a>
                  </Link>
                </MediaNavItem>
                <MediaNavItem>
                  <Link to="https://twitter.com/binance">
                    <a target="_blank" aria-label="Twitter" id="Community-a-bannerTwitter">
                      <Icon type="twitter" size={50} />
                      <Introduction>Twitter</Introduction>
                    </a>
                  </Link>
                </MediaNavItem>
                <MediaNavItem>
                  <Link to="https://www.reddit.com/r/binanceexchange">
                    <a target="_blank" aria-label="Reddit" id="Community-a-bannerReddit">
                      <Icon type="reddit" size={50} />
                      <Introduction>Reddit</Introduction>
                    </a>
                  </Link>
                </MediaNavItem>
                <MediaNavItem>
                  <Link to="https://weibo.com/binance?is_hot=1">
                    <a target="_blank" aria-label="Weibo" id="Community-a-bannerWeibo">
                      <Icon type="weibo" size={50} />
                      <Introduction>Weibo</Introduction>
                    </a>
                  </Link>
                </MediaNavItem>
                <MediaNavItem>
                  <Link to="https://www.linkedin.com/company/binance">
                    <a target="_blank" aria-label="linkedin" id="Community-a-bannerLinkedIn">
                      <Icon type="linkedin" size={50} />
                      <Introduction>LinkedIn</Introduction>
                    </a>
                  </Link>
                </MediaNavItem>
                <MediaNavItem>
                  <Link to="https://www.instagram.com/binanceexchange/">
                    <a target="_blank" aria-label="Instagram" id="Community-a-bannerInstagram">
                      <Icon type="instagram" size={50} />
                      <Introduction>Instagram</Introduction>
                    </a>
                  </Link>
                </MediaNavItem>
                <MediaNavItem>
                  <Link to="https://vk.com/binancerussia">
                    <a target="_blank" aria-label="VK" id="Community-a-bannerVK">
                      <Icon type="vk" size={50} />
                      <Introduction>VK</Introduction>
                    </a>
                  </Link>
                </MediaNavItem>
              </MediaNavList>
            </div>
          </div>
        </HeadBox>

        <CategoryList id="goTG">
          <Container>
            <BannersTitle hasColor="true" hasMargin="true">
              {getLabel('exchange-community-officialTelegramChannels', i18n)}
            </BannersTitle>

            <BannersToUnderstanding hasMarginTop="true">
              {getLabel('exchange-community-discussion', i18n)}
            </BannersToUnderstanding>

            <ListHeaderLogo>
              <Icon type="exchange" size={80} color="#F0B90B" />
            </ListHeaderLogo>

            <ListOne>
              <ListHeaderTitle>Exchange</ListHeaderTitle>
              <RowFlxBox justify="space-between">
                <TGChannelItem largeWidth="true" hasMargin={true}>
                  <h4>
                    {getLabel('exchange-community-english', i18n)}
                    <CenterIcon
                      copylinkId="Community-a-copylinkExchangeEn"
                      shareId="Community-a-shareExchangeEn"
                      className="iconBtn"
                      copyMsg={() => {
                        copyText('https://t.me/BinanceExchange');
                      }}
                      shareFacebook={() => {
                        window.open(
                          `https://www.facebook.com/sharer/sharer.php?u=${'https://t.me/BinanceExchange'}&t=${'分享主题'}`,
                          '_blank'
                        );
                      }}
                      shareFacebookId="Community-a-ExchangeBinanceEnFacebook"
                      shareTwitter={() => {
                        window.open(
                          `https://twitter.com/intent/tweet?text=${'分享内容'}&url=${'https://t.me/BinanceExchange'}`,
                          '_blank'
                        );
                      }}
                      shareTwitterId="Community-a-ExchangeBinanceEnTwitter"
                      shareLinkedIn={() => {
                        window.open(
                          `http://www.linkedin.com/shareArticle?mini=true&ro=true&title=
                      ${'分享主题'}&url=${'https://t.me/BinanceExchange'}&summary=${'分享内容'}&source=${'分享内容'}&armin=armin`,
                          '_blank'
                        );
                      }}
                      shareLinkedInId="Community-a-ExchangeBinanceEnLinkedIn"
                      shareWeibo={() => {
                        window.open(
                          `http://service.weibo.com/share/share.php?url=${'https://t.me/BinanceExchange'}&title=
                      ${'分享主题'}&pic=#_loginLayer_1508918957506`,
                          '_blank'
                        );
                      }}
                      shareWeiboId="Community-a-ExchangeBinanceEnWeibo"
                      shareQq={() => {
                        window.open(
                          `http://connect.qq.com/widget/shareqq/index.html?url=${'https://t.me/BinanceExchange'}&title=
                      ${'分享主题'}&desc=${'分享内容'}`,
                          '_blank'
                        );
                      }}
                      shareQqId="Community-a-ExchangeBinanceEnQQ"
                    />
                  </h4>
                  <Link to="https://t.me/BinanceExchange">
                    <a id="Community-a-BinanceExchange" target="_blank">
                      https://t.me/BinanceExchange
                    </a>
                  </Link>
                </TGChannelItem>
                <TGChannelItem largeWidth="true" hasMargin={true}>
                  <h4>
                    {getLabel('exchange-community-chinese', i18n)}
                    <CenterIcon
                      copylinkId="Community-a-copylinkExchangeChinese"
                      shareId="Community-a-shareExchangeChinese"
                      className="iconBtn"
                      copyMsg={() => {
                        copyText('https://t.me/BinanceChinese');
                      }}
                      shareFacebook={() => {
                        window.open(
                          `https://www.facebook.com/sharer/sharer.php?u=${'https://t.me/BinanceChinese'}&t=${'分享主题'}`,
                          '_blank'
                        );
                      }}
                      shareFacebookId="Community-a-ExchangeBinanceCnFacebook"
                      shareTwitter={() => {
                        window.open(
                          `https://twitter.com/intent/tweet?text=${'分享内容'}&url=${'https://t.me/BinanceChinese'}`,
                          '_blank'
                        );
                      }}
                      shareTwitterId="Community-a-ExchangeBinanceCnTwitter"
                      shareLinkedIn={() => {
                        window.open(
                          `http://www.linkedin.com/shareArticle?mini=true&ro=true&title=
                      ${'分享主题'}&url=${'https://t.me/BinanceChinese'}&summary=${'分享内容'}&source=${'分享内容'}&armin=armin`,
                          '_blank'
                        );
                      }}
                      shareLinkedInId="Community-a-ExchangeBinanceCnLinkedIn"
                      shareWeibo={() => {
                        window.open(
                          `http://service.weibo.com/share/share.php?url=${'https://t.me/BinanceChinese'}&title=
                      ${'分享主题'}&pic=#_loginLayer_1508918957506`,
                          '_blank'
                        );
                      }}
                      shareWeiboId="Community-a-ExchangeBinanceCnWeibo"
                      shareQq={() => {
                        window.open(
                          `http://connect.qq.com/widget/shareqq/index.html?url=${'https://t.me/BinanceChinese'}&title=
                      ${'分享主题'}&desc=${'分享内容'}`,
                          '_blank'
                        );
                      }}
                      shareQqId="Community-a-ExchangeBinanceCnQQ"
                    />
                  </h4>
                  <Link to="https://t.me/BinanceChinese">
                    <a id="Community-a-BinanceExchangeChinese" target="_blank">
                      https://t.me/BinanceChinese
                    </a>
                  </Link>
                </TGChannelItem>
                <TGChannelItem largeWidth="true" hasMargin={true}>
                  <h4>
                    {getLabel('exchange-community-announcements', i18n)}
                    <CenterIcon
                      copylinkId="Community-a-copylinkExchangeAnnouncements"
                      shareId="Community-a-shareExchangeAnnouncements"
                      className="iconBtn"
                      copyMsg={() => {
                        copyText('https://t.me/binance_announcements');
                      }}
                      shareFacebook={() => {
                        window.open(
                          `https://www.facebook.com/sharer/sharer.php?u=${'https://t.me/binance_announcements'}&t=${'分享主题'}`,
                          '_blank'
                        );
                      }}
                      shareFacebookId="Community-a-ExchangeAnnouncementsFacebook"
                      shareTwitter={() => {
                        window.open(
                          `https://twitter.com/intent/tweet?text=${'分享内容'}&url=${'https://t.me/binance_announcements'}`,
                          '_blank'
                        );
                      }}
                      shareTwitterId="Community-a-ExchangeAnnouncementsTwitter"
                      shareLinkedIn={() => {
                        window.open(
                          `http://www.linkedin.com/shareArticle?mini=true&ro=true&title=
                      ${'分享主题'}&url=${'https://t.me/binance_announcements'}&summary=${'分享内容'}&source=${'分享内容'}&armin=armin`,
                          '_blank'
                        );
                      }}
                      shareLinkedInId="Community-a-ExchangeAnnouncementsLinkedIn"
                      shareWeibo={() => {
                        window.open(
                          `http://service.weibo.com/share/share.php?url=${'https://t.me/binance_announcements'}&title=
                      ${'分享主题'}&pic=#_loginLayer_1508918957506`,
                          '_blank'
                        );
                      }}
                      shareWeiboId="Community-a-ExchangeAnnouncementsWeibo"
                      shareQq={() => {
                        window.open(
                          `http://connect.qq.com/widget/shareqq/index.html?url=${'https://t.me/binance_announcements'}&title=
                      ${'分享主题'}&desc=${'分享内容'}`,
                          '_blank'
                        );
                      }}
                      shareQqId="Community-a-ExchangeAnnouncementsQQ"
                    />
                  </h4>
                  <Link to="https://t.me/binance_announcements">
                    <a target="_blank">https://t.me/binance_announcements</a>
                  </Link>
                </TGChannelItem>
              </RowFlxBox>
            </ListOne>

            <ListOne>
              <ListHeaderTitle>Academy</ListHeaderTitle>
              <RowFlxBox justify="space-between">
                <TGChannelItem largeWidth="true" hasMargin={true}>
                  <h4>
                    {getLabel('exchange-community-announcements', i18n)}
                    <CenterIcon
                      copylinkId="Community-a-copylinkAcademyAnnouncements"
                      shareId="Community-a-shareAcademyAnnouncements"
                      className="iconBtn"
                      copyMsg={() => {
                        copyText('https://t.me/BinanceAcademy');
                      }}
                      shareFacebook={() => {
                        window.open(
                          `https://www.facebook.com/sharer/sharer.php?u=${'https://t.me/BinanceAcademy'}&t=${'分享主题'}`,
                          '_blank'
                        );
                      }}
                      shareFacebookId="Community-a-AcademyAnnouncementsFacebook"
                      shareTwitter={() => {
                        window.open(
                          `https://twitter.com/intent/tweet?text=${'分享内容'}&url=${'https://t.me/BinanceAcademy'}`,
                          '_blank'
                        );
                      }}
                      shareTwitterId="Community-a-AcademyAnnouncementsTwitter"
                      shareLinkedIn={() => {
                        window.open(
                          `http://www.linkedin.com/shareArticle?mini=true&ro=true&title=
                      ${'分享主题'}&url=${'https://t.me/BinanceAcademy'}&summary=${'分享内容'}&source=${'分享内容'}&armin=armin`,
                          '_blank'
                        );
                      }}
                      shareLinkedInId="Community-a-AcademyAnnouncementsLinkedIn"
                      shareWeibo={() => {
                        window.open(
                          `http://service.weibo.com/share/share.php?url=${'https://t.me/BinanceAcademy'}&title=
                      ${'分享主题'}&pic=#_loginLayer_1508918957506`,
                          '_blank'
                        );
                      }}
                      shareWeiboId="Community-a-AcademyAnnouncementsEnWeibo"
                      shareQq={() => {
                        window.open(
                          `http://connect.qq.com/widget/shareqq/index.html?url=${'https://t.me/BinanceAcademy'}&title=
                      ${'分享主题'}&desc=${'分享内容'}`,
                          '_blank'
                        );
                      }}
                      shareQqId="Community-a-AcademyAnnouncementsQQ"
                    />
                  </h4>
                  <Link to="https://t.me/BinanceAcademy">
                    <a id="Community-a-AcademyAnnouncements" target="_blank">
                      https://t.me/BinanceAcademy
                    </a>
                  </Link>
                </TGChannelItem>
                <TGChannelItem largeWidth="true" hasMargin={true}>
                  <h4>
                    {getLabel('exchange-community-discussionTow', i18n)}
                    <CenterIcon
                      copylinkId="Community-a-copyAcademyDiscussionTow"
                      shareId="Community-a-shareAcademyDiscussionTow"
                      className="iconBtn"
                      copyMsg={() => {
                        copyText('https://t.me/BinanceAcademyChat');
                      }}
                      shareFacebook={() => {
                        window.open(
                          `https://www.facebook.com/sharer/sharer.php?u=${'https://t.me/BinanceAcademyChat'}&t=${'分享主题'}`,
                          '_blank'
                        );
                      }}
                      shareFacebookId="Community-a-DiscussionTowFacebook"
                      shareTwitter={() => {
                        window.open(
                          `https://twitter.com/intent/tweet?text=${'分享内容'}&url=${'https://t.me/BinanceAcademyChat'}`,
                          '_blank'
                        );
                      }}
                      shareTwitterId="Community-a-DiscussionTowTwitter"
                      shareLinkedIn={() => {
                        window.open(
                          `http://www.linkedin.com/shareArticle?mini=true&ro=true&title=
                      ${'分享主题'}&url=${'https://t.me/BinanceAcademyChat'}&summary=${'分享内容'}&source=${'分享内容'}&armin=armin`,
                          '_blank'
                        );
                      }}
                      shareLinkedInId="Community-a-DiscussionTowLinkedIn"
                      shareWeibo={() => {
                        window.open(
                          `http://service.weibo.com/share/share.php?url=${'https://t.me/BinanceAcademyChat'}&title=
                      ${'分享主题'}&pic=#_loginLayer_1508918957506`,
                          '_blank'
                        );
                      }}
                      shareWeiboId="Community-a-DiscussionTowWeibo"
                      shareQq={() => {
                        window.open(
                          `http://connect.qq.com/widget/shareqq/index.html?url=${'https://t.me/BinanceAcademyChat'}&title=
                      ${'分享主题'}&desc=${'分享内容'}`,
                          '_blank'
                        );
                      }}
                      shareQqId="Community-a-DiscussionTowQQ"
                    />
                  </h4>
                  <Link to="https://t.me/BinanceAcademyChat">
                    <a id="Community-a-DiscussionTow" target="_blank">
                      https://t.me/BinanceAcademyChat
                    </a>
                  </Link>
                </TGChannelItem>
                <div style={{ width: '33.33%', float: 'left' }} />
              </RowFlxBox>
            </ListOne>

            <ListOne>
              <ListHeaderTitle>Info</ListHeaderTitle>
              <RowFlxBox justify="space-between">
                <TGChannelItem largeWidth="true" hasMargin={true}>
                  <h4>
                    {getLabel('exchange-community-english', i18n)}
                    <CenterIcon
                      copylinkId="Community-a-copyInfoEn"
                      shareId="Community-a-shareInfoEn"
                      className="iconBtn"
                      copyMsg={() => {
                        copyText('https://t.me/Binance_Info_English');
                      }}
                      shareFacebook={() => {
                        window.open(
                          `https://www.facebook.com/sharer/sharer.php?u=${'https://t.me/Binance_Info_English'}&t=${'分享主题'}`,
                          '_blank'
                        );
                      }}
                      shareFacebookId="Community-a-InfoEnFacebook"
                      shareTwitter={() => {
                        window.open(
                          `https://twitter.com/intent/tweet?text=${'分享内容'}&url=${'https://t.me/Binance_Info_English'}`,
                          '_blank'
                        );
                      }}
                      shareTwitterId="Community-a-InfoEnTwitter"
                      shareLinkedIn={() => {
                        window.open(
                          `http://www.linkedin.com/shareArticle?mini=true&ro=true&title=
                      ${'分享主题'}&url=${'https://t.me/Binance_Info_English'}&summary=${'分享内容'}&source=${'分享内容'}&armin=armin`,
                          '_blank'
                        );
                      }}
                      shareLinkedInId="Community-a-InfoEnLinkedIn"
                      shareWeibo={() => {
                        window.open(
                          `http://service.weibo.com/share/share.php?url=${'https://t.me/Binance_Info_English'}&title=
                      ${'分享主题'}&pic=#_loginLayer_1508918957506`,
                          '_blank'
                        );
                      }}
                      shareWeiboId="Community-a-InfoEnWeibo"
                      shareQq={() => {
                        window.open(
                          `http://connect.qq.com/widget/shareqq/index.html?url=${'https://t.me/Binance_Info_English'}&title=
                      ${'分享主题'}&desc=${'分享内容'}`,
                          '_blank'
                        );
                      }}
                      shareQqId="Community-a-InfoEnQQ"
                    />
                  </h4>

                  <Link to="https://t.me/Binance_Info_English">
                    <a id="Community-a-InfoEn" target="_blank">
                      https://t.me/Binance_Info_English
                    </a>
                  </Link>
                </TGChannelItem>
                <TGChannelItem largeWidth="true" hasMargin={true}>
                  <h4>
                    {getLabel('exchange-community-research', i18n)}
                    <CenterIcon
                      copylinkId="Community-a-copylinkResearch"
                      shareId="Community-a-shareResearch"
                      className="iconBtn"
                      copyMsg={() => {
                        copyText('https://t.me/BinanceResearch');
                      }}
                      shareFacebook={() => {
                        window.open(
                          `https://www.facebook.com/sharer/sharer.php?u=${'https://t.me/BinanceResearch'}&t=${'分享主题'}`,
                          '_blank'
                        );
                      }}
                      shareFacebookId="Community-a-InfoResearchFacebook"
                      shareTwitter={() => {
                        window.open(
                          `https://twitter.com/intent/tweet?text=${'分享内容'}&url=${'https://t.me/BinanceResearch'}`,
                          '_blank'
                        );
                      }}
                      shareTwitterId="Community-a-InfoResearchTwitter"
                      shareLinkedIn={() => {
                        window.open(
                          `http://www.linkedin.com/shareArticle?mini=true&ro=true&title=
                      ${'分享主题'}&url=${'https://t.me/BinanceResearch'}&summary=${'分享内容'}&source=${'分享内容'}&armin=armin`,
                          '_blank'
                        );
                      }}
                      shareLinkedInId="Community-a-InfoResearchLinkedIn"
                      shareWeibo={() => {
                        window.open(
                          `http://service.weibo.com/share/share.php?url=${'https://t.me/BinanceResearch'}&title=
                      ${'分享主题'}&pic=#_loginLayer_1508918957506`,
                          '_blank'
                        );
                      }}
                      shareWeiboId="Community-a-InfoResearchWeibo"
                      shareQq={() => {
                        window.open(
                          `http://connect.qq.com/widget/shareqq/index.html?url=${'https://t.me/BinanceResearch'}&title=
                      ${'分享主题'}&desc=${'分享内容'}`,
                          '_blank'
                        );
                      }}
                      shareQqId="Community-a-InfoResearchQQ"
                    />
                  </h4>
                  <Link to="https://t.me/BinanceResearch">
                    <a id="Community-a-InfoResearch" target="_blank">
                      https://t.me/BinanceResearch
                    </a>
                  </Link>
                </TGChannelItem>
                <div style={{ width: '33.33%', float: 'left' }} />
              </RowFlxBox>
            </ListOne>
          </Container>
        </CategoryList>

        <LowerMiddle>
          <Container>
            <h3>{getLabel('exchange-community-telegramCommunities', i18n)}</h3>

            <h4>{getLabel('exchange-community-global', i18n)}</h4>

            <LanguageDropDownBox defaultChecked={true} justify="space-between">
              <LanguageSelect>
                <span className="LanguageSelectSpan">
                  <Icon type="Language" size={25} color="#000000" /> |
                </span>
                <WrapSelect
                  showSearch={true}
                  style={{
                    width: '400px',
                    color: '#848E9C',
                    fontSize: '14px',
                  }}
                  value={this.state.lang}
                  onChange={this.selectChange}
                >
                  {languageOptions.map(item => (
                    <Select.Option value={item.name}>{item.name}</Select.Option>
                  ))}
                </WrapSelect>
              </LanguageSelect>
            </LanguageDropDownBox>

            <CommunitiesItemWrap>
              <h2>Exchange</h2>
              {selectCommunityOptions.map((item, i) => (
                <TGChannelItem hasMarginTop={false} largeWidth={false} key={i}>
                  <h4 style={{ textAlign: 'start', marginBottom: '0.5em', marginTop: 0 }}>
                    {item.name}:
                    <CenterIcon
                      copylinkId={`Community-a-copyExchange_${i + 1}`}
                      shareId={`Community-a-shareExchange_${i + 1}`}
                      className="iconBtn"
                      copyMsg={() => {
                        copyText(item.link);
                      }}
                      shareFacebook={() => {
                        window.open(
                          `https://www.facebook.com/sharer/sharer.php?u=${
                            item.link
                          }&t=${'分享主题'}`,
                          '_blank'
                        );
                      }}
                      shareFacebookId={`Community-a-Exchange_${i + 1}_Facebook`}
                      shareTwitter={() => {
                        window.open(
                          `https://twitter.com/intent/tweet?text=${'分享内容'}&url=${item.link}`,
                          '_blank'
                        );
                      }}
                      shareTwitterId={`Community-a-Exchange_${i + 1}_Twitter`}
                      shareLinkedIn={() => {
                        window.open(
                          `http://www.linkedin.com/shareArticle?mini=true&ro=true&title=${'分享主题'}&url=${
                            item.link
                          }&summary=
                      ${'分享内容'}&source=${'分享内容'}&armin=armin`,
                          '_blank'
                        );
                      }}
                      shareLinkedInId={`Community-a-Exchange_${i + 1}_LinkedIn`}
                      shareWeibo={() => {
                        window.open(
                          `http://service.weibo.com/share/share.php?url=${item.link}&title=
                      ${'分享主题'}&pic=#_loginLayer_1508918957506`,
                          '_blank'
                        );
                      }}
                      shareWeiboId={`Community-a-Exchange_${i + 1}_Weibo`}
                      shareQq={() => {
                        window.open(
                          `http://connect.qq.com/widget/shareqq/index.html?url=${item.link}&title=
                      ${'分享主题'}&desc=${'分享内容'}`,
                          '_blank'
                        );
                      }}
                      shareQqId={`Community-a-Exchange_${i + 1}_QQ`}
                    />
                  </h4>
                  <Link to={item.link}>
                    <a id={`Community-a-Exchange_${i + 1}`} target="_blank">
                      {item.link}
                    </a>
                  </Link>
                </TGChannelItem>
              ))}
            </CommunitiesItemWrap>
          </Container>
        </LowerMiddle>
      </Wrap>
    );
  }
}
